import React, { useState,useEffect } from 'react';
import {
  Button,
  Stack,
  Container,
  Breadcrumb,
  Divider,
  Uploader,
  Table,
  Checkbox,
  Input,
  useToaster,
  Message,
  IconButton,
  Modal,
  FlexboxGrid,
  Col,
  SelectPicker,
  InputPicker
} from 'rsuite';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import TrashIcon from '@rsuite/icons/Trash';


const sizeUnit = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];

const BulkProduct = () => {
  const ip = 'http://192.168.1.23:1337';
  const toaster = useToaster();
  const [category, setCategory] = useState(true);
  const [Productype, setProductype] = useState(true);
  const [image, setImage] = useState(true);
  const [collection, setCollection] = useState(true);
  const [sellingPrice, setSellingPrice] = useState(false);
  const [moq, setMoq] = useState(false);
  const [description, setDescription] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(false);
  const [productCost, setProductCost] = useState(false);
  const [material, setMaterial] = useState(false);
  const [color, setColor] = useState(true);
  const [productID, setProductID] = useState(false);
  const [productname, setProductname] = useState(false);
  const [size, setSize] = useState(true);
  const [finish, setFinish] = useState(true);
  const [netWeight, setNetWeight] = useState(false);
  const [grossweight, setGrossweight] = useState(false);
  const [hsn, setHsn] = useState(false);
  const [sellingpriceU, setSellingpriceU] = useState(false);
  const [sellingpriceC, setSellingpriceC] = useState(false);
  const [productDesigner, setProductDesigner] = useState(false);
  const [madeby, setMadeby] = useState(false);
  const [buyername, setBuyername] = useState(false);
  const [buyersku, setBuyersku] = useState(false);
  const [length, setLength] = useState(true);
  const [width, setWidth] = useState(true);
  const [height, setHeight] = useState(true);
  const [cbm, setCbm] = useState(true);

  const url2 = `${ip}/api/products`;
  const submit = e => {
    if (rows.some(row => row.CategoryCode === '')) {
      toaster.push(
        <Message showIcon type='error' >
          Please add at least one Product.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    // else if (rows.some(row => row.CoverImage === null)){
    //   toaster.push(
    //     <Message showIcon type='error' closable>
    //       Please add at least one Image.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    // }
    else {
      e.preventDefault();
      for (let i = 0; i < rows.length; i++) {
        const formData = new FormData();
        const copiedRows = rows.map(({ id, ...rest }) => rest);
        const arr1 = copiedRows[i];
        formData.append('files.CoverImage', arr1.CoverImage);
        formData.append('data', JSON.stringify(arr1));
        console.log(arr1)
        fetch(url2, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            // Refresh page after 2 seconds (3000 milliseconds)
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          })
          .catch(error => console.error(error));
      }
      toaster.push(<Message showIcon type='success' >
        Saved Successfully
      </Message>, { placement: 'topCenter' });
    }
  };

  const [rows, setRows] = useState([{
    id: 1,
    CategoryCode: '',
    ProductTypeCode: '',
    ProductCode: '',
    ProductId: "",
    ProductName: "",
    Description: "",
    SizeUnit: "",
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: "",
    ColorCode: "",
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: "",
    SellingPriceCurrency: "",
    SellingPriceUnit: "",
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: "",
    MOQ: "",
    ProductDesigner: "",
    MadeBy: "",
    CategoryName: "",
    ProductTypeName: "",
    cbm: 0,
    FinishName: "",
    ColorName: "",
    BuyerName: "",
    BuyerSku: "",
    MaterialCollection: [
      {
        ProductCode: "",
        MatCollectionNm: "",
        MatCollectionCode: ""
      }
    ],
    ProductionDetail: [
      {
          ProductCode: "",
          MaterialNm: "",
          MaterialFinishNm: "",
          MatNetWeight: 0,
          MaterialCode: "",
          MaterialFinishCode: ""
      }
  ],
    CoverImage: null,
    MultipleImage: null
  }]);

  const handleAddRow = () => {
  setRows([...rows, {
    id: rows.length + 1,
    CategoryCode: "",
    ProductTypeCode: "",
    ProductCode: "",
    ProductId: "",
    ProductName: "",
    Description: "",
    SizeUnit: "",
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: "",
    ColorCode: "",
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: "",
    SellingPriceCurrency: "",
    SellingPriceUnit: "",
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: "",
    MOQ: "",
    ProductDesigner: "",
    MadeBy: "",
    CategoryName: "",
    ProductTypeName: "",
    cbm: 0,
    FinishName: "",
    ColorName: "",
    BuyerName: "",
    BuyerSku: "",
    MaterialCollection: [
      {
        ProductCode: "",
        MatCollectionNm: "",
        MatCollectionCode: ""
      }
    ],
    ProductionDetail: [
      {
          ProductCode: "",
          MaterialNm: "",
          MaterialFinishNm: "",
          MatNetWeight: 0,
          MaterialCode: "",
          MaterialFinishCode: ""
      }
  ],
    CoverImage: null,
    MultipleImage: null

    }]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };

  const handleChange = (index, inputName, value) => {
    if (inputName === "FinishName") {
      const selectedFinish = finishdata.find(item => item.label === value);
      setRows(prevData => ({
        ...prevData,
        FinishName: value,
        FinishCode: selectedFinish ? selectedFinish.value : "",
      }));
    }
    const updatedRows = [...rows];
    updatedRows[index][inputName] = value;
    setRows(updatedRows);
  };

  const handleImageUpload = (fileList, rowIndex) => {
    const updatedRows = [...rows];
    updatedRows[rowIndex] = {
      ...updatedRows[rowIndex],
      CoverImage: fileList[0].blobFile
    };
    setRows(updatedRows);
  };

  const handleimageCheckbox = () => {
    setImage(!image);
  };
  const handlecategoryCheckbox = () => {
    setCategory(!category);
  };
  const handlesubCategoryCheckbox = () => {
    setProductype(!Productype);
  };
  const handlemodularSizeCheckbox = () => {
    setCollection(!collection);
  };
  const handlesellingPriceCheckbox = () => {
    setSellingPrice(!sellingPrice);
  };
  const handlemoqCheckbox = () => {
    setMoq(!moq);
  };
  const handledescriptionCheckbox = () => {
    setDescription(!description);
  };
  const handlesearchKeywordCheckbox = () => {
    setSearchKeyword(!searchKeyword);
  };
  const handlenameCheckbox = () => {
    setProductID(!productID);
  };
  const handleproductionTimeCheckbox = () => {
    setProductname(!productname);
  };
  const handleremarksCheckbox = () => {
    setFinish(!finish);
  };
  const handlesamplingTimeCheckbox = () => {
    setNetWeight(!netWeight);
  };
  const handleproductionTechCheckbox = () => {
    setGrossweight(!grossweight);
  };
  const handleproductCostCheckbox = () => {
    setProductCost(!productCost);
  };
  const handlepriceFromeVendorCheckbox = () => {
    setHsn(!hsn);
  };
  const handledispatchDataCheckbox = () => {
    setSellingpriceU(!sellingpriceU);
  };
  const handlematerialCheckbox = () => {
    setMaterial(!material);
  };
  const handlecolorCheckbox = () => {
    setColor(!color);
  };
  const handleseasonCheckbox = () => {
    setSellingpriceC(!sellingpriceC);
  };
  const handleexclusiveForCheckbox = () => {
    setProductDesigner(!productDesigner);
  };
  const handlesizeCheckbox = () => {
    setSize(!size);
  };
  const handleshapeCheckbox = () => {
    setMadeby(!madeby);
  };
  const handlevendornameCheckbox = () => {
    setBuyername(!buyername);
  };
  const handlethemeCheckbox = () => {
    setBuyersku(!buyersku);
  };
  const handlelenghtCheckbox = () => {
    setLength(!length);
  };
  const handlewidthCheckbox = () => {
    setWidth(!width);
  };
  const handleheightCheckbox = () => {
    setHeight(!height);
  };
  const handlecbmCheckbox = () => {
    setCbm(!cbm);
  };

  const [open, setOpen] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen = value => {
    setSize1(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  //category data fetch start
  const [categorydata, setCategorydata] = React.useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcategories`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode,
      }));
      setCategorydata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //category data fetch end

  //product type data fetch start
  const [productypedata, setProductypedata] = React.useState([]);
  useEffect(() => {
    fetchData2();
  }, []);
  const fetchData2 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstproducttypes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode,
      }));
      setProductypedata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  //product type data fetch end

   //Collection type data fetch start
   const [collectiondata, setCollectiondata] = React.useState([]);
   useEffect(() => {
     fetchData3();
   }, []);
   const fetchData3 = async () => {
     try {
       const response = await fetch(`${ip}/api/mstmaterialcollections`);
       const json = await response.json();
       const processedData = json.data.map((item) => ({
         label: item.attributes.MatCollectionName,
         value: item.attributes.MatCollectionCode,
       }));
       setCollectiondata(processedData);
     } catch (error) {
       console.error('Error fetching category data:', error);
     }
   };
   //Collection type data fetch end
   //Finish type data fetch start
   const [finishdata, setFinishdata] = React.useState([]);
   useEffect(() => {
     fetchData4();
   }, []);
   const fetchData4 = async () => {
     try {
       const response = await fetch(`${ip}/api/mstfinishes`);
       const json = await response.json();
       const processedData = json.data.map((item) => ({
         label: item.attributes.FinishName,
         value: item.attributes.FinishCode,
       }));
       setFinishdata(processedData);
     } catch (error) {
       console.error('Error fetching category data:', error);
     }
   };
   //Finish type data fetch end
   //color type data fetch start
   const [colordata, setColordata] = React.useState([]);
   useEffect(() => {
     fetchData5();
   }, []);
   const fetchData5 = async () => {
     try {
       const response = await fetch(`${ip}/api/mstcolors`);
       const json = await response.json();
       const processedData = json.data.map((item) => ({
         label: item.attributes.ColorName,
         value: item.attributes.ColorCode,
       }));
       setColordata(processedData);
     } catch (error) {
       console.error('Error fetching category data:', error);
     }
   };
   //color type data fetch end
   //hsn type data fetch start
   const [hsndata, setHsndata] = React.useState([]);
   useEffect(() => {
     fetchData6();
   }, []);
   const fetchData6 = async () => {
     try {
       const response = await fetch(`${ip}/api/msthscodes`);
       const json = await response.json();
       const processedData = json.data.map((item) => ({
         label: item.attributes.hscode,
         value: item.attributes.hscode,
       }));
       setHsndata(processedData);
     } catch (error) {
       console.error('Error fetching category data:', error);
     }
   };
   //hsn type data fetch end
   //material type data fetch start
   const [materialdata, setMaterialdata] = React.useState([]);
   useEffect(() => {
     fetchData7();
   }, []);
   const fetchData7 = async () => {
     try {
       const response = await fetch(`${ip}/api/mstmaterials`);
       const json = await response.json();
       const processedData = json.data.map((item) => ({
         label: item.attributes.MaterialName,
         value: item.attributes.MaterialCode,
       }));
       setMaterialdata(processedData);
     } catch (error) {
       console.error('Error fetching category data:', error);
     }
   };
   //material type data fetch end


  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Bulk Upload</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/products">Product</Breadcrumb.Item>
                <Breadcrumb.Item active>Bulk Upload Products</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>
          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack spacing={10}>
              <Button appearance='subtle' active>
                Import data
              </Button>
              <Button appearance="ghost" color='cyan' active onClick={() => handleOpen('sm')}>
                Customize Table
              </Button>
              <Button appearance="primary" color='cyan' active onClick={submit}>
                Upload all products
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />

        <Table
          height={400}
          rowHeight={80}
          data={rows}
          style={{ marginBottom: '20px' }}
        >
          <Table.Column width={50} fixed>
            <Table.HeaderCell><b>ID</b></Table.HeaderCell>
            <Table.Cell dataKey='id'>
            </Table.Cell>
          </Table.Column>
          {image && (
            <Table.Column width={100} >
              <Table.HeaderCell><b>Image</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => (
                  <Uploader listType="picture" action="http://192.168.1.3:1337/api/products" onChange={(fileList) => handleImageUpload(fileList, rowIndex)} style={{ marginTop: '-16px' }}>
                    <button>
                      <CameraRetroIcon />
                    </button>
                  </Uploader>
                )}
              </Table.Cell>
            </Table.Column>
          )}
          {category && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Category</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => (
                  <SelectPicker
                  id="CategoryCode"
                  name="CategoryCode"
                  value={rowData && rowData.CategoryCode ? rowData.CategoryCode : ''}
                  onChange={value => handleChange(rowIndex,'CategoryCode', value)}
                  data={categorydata}
                  placeholder="Select"
                  labelKey="label"
                  valueKey="value"
                  block
                />
                  // <Input
                  //   name="Category"
                  //   value={rowData.Category}
                  //   onChange={(value) => handleChange(rowIndex, "Category", value)}
                  // />
                )}
              </Table.Cell>
            </Table.Column>
          )}
          {Productype && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Product Type</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <SelectPicker
                id="ProductTypeCode"
                name="ProductTypeCode"
                value={rowData && rowData.ProductTypeCode ? rowData.ProductTypeCode : ''}
                onChange={value => handleChange(rowIndex,'ProductTypeCode', value)}
                data={productypedata}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                // <Input
                //   value={rowData.ProductType}
                //   onChange={(value) => handleChange(rowIndex, 'ProductType', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {collection && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Collection</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <SelectPicker
                // id="ProductTypeCode"
                // name="ProductTypeCode"
                // value={rowData && rowData.ProductTypeCode ? rowData.ProductTypeCode : ''}
                // onChange={value => handleChange(rowIndex,'ProductTypeCode', value)}
                data={collectiondata}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                // <Input
                //   value={rowData.ProductCode}
                //   onChange={(value) => handleChange(rowIndex, 'ProductCode', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {productID && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Prodcut ID</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='ProductId' name="ProductId" 
                value={rowData && rowData.ProductId ? rowData.ProductId : ''}
                 onChange={value => handleChange(rowIndex,'ProductId', value)} />
                // <Input
                //   value={rowData.ProductCode}
                //   onChange={(value) => handleChange(rowIndex, 'ProductCode', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {productname && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Product Name</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='ProductName' name="ProductName" 
                value={rowData && rowData.ProductName ? rowData.ProductName : ''}
                 onChange={value => handleChange(rowIndex,'ProductName', value)} />
                // <Input
                //   value={rowData.name}
                //   onChange={(value) => handleChange(rowIndex, 'name', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {size && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>SizeUnit</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <InputPicker
                data={sizeUnit}
                id="SizeUnit"
                name="SizeUnit"
                value={rowData && rowData.SizeUnit ? rowData.SizeUnit : ''}
                onChange={value => handleChange(rowIndex,'SizeUnit', value)}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                //  <Input
                //   value={rowData.size}
                //   onChange={(value) => handleChange(rowIndex, 'remarks', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {length && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Length</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <Input id='Length' name="Length" 
                value={rowData && rowData.Length ? rowData.Length : ''}
                 onChange={value => handleChange(rowIndex,'Length', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {width && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Width</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='Width' name="Width" 
                value={rowData && rowData.Width ? rowData.Width : ''}
                 onChange={value => handleChange(rowIndex,'Width', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {height && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Height</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <Input id='Height' name="Height" 
                value={rowData && rowData.Height ? rowData.Height : ''}
                 onChange={value => handleChange(rowIndex,'Height', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {cbm && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>CBM</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='cbm' name="cbm" 
                 value={rowData && rowData.cbm ? rowData.cbm : ''}
                  onChange={value => handleChange(rowIndex,'cbm', value)} readOnly />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {finish && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Finish</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <SelectPicker
                id="FinishName"
                name="FinishName"
                value={rowData.FinishName || ""}
                onChange={value => handleChange(rowIndex,"FinishName", value)}
                data={finishdata}
                placeholder="Select"
                labelKey="label"
                valueKey="label"
                block
              />
                //  <Input
                //   value={rowData.samplingTime}
                //   onChange={(value) => handleChange(rowIndex, 'samplingTime', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {color && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Color</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <SelectPicker
                id="ColorName"
                name="ColorName"
                value={rowData && rowData.ColorName ? rowData.ColorName : ''}
                onChange={value => handleChange(rowIndex,'ColorName', value)}
                data={colordata}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                //  <Input
                //   value={rowData.color}
                //   onChange={(value) => handleChange(rowIndex, 'color', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {description && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Description</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='Description' name="Description" 
                 value={rowData && rowData.Description ? rowData.Description : ''}
                  onChange={value => handleChange(rowIndex,'Description', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {netWeight && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Net Wt.</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='NetWeight' name="NetWeight" 
                 value={rowData && rowData.NetWeight ? rowData.NetWeight : ''}
                  onChange={value => handleChange(rowIndex,'NetWeight', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {grossweight && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Gross Wt.</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='GrossWeight' name="GrossWeight" 
                value={rowData && rowData.GrossWeight ? rowData.GrossWeight : ''}
                 onChange={value => handleChange(rowIndex,'GrossWeight', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {hsn && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>HSN</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                <SelectPicker
                id="HSNCode"
                name="HSNCode"
                value={rowData && rowData.HSNCode ? rowData.HSNCode : ''}
                onChange={value => handleChange(rowIndex,'HSNCode', value)}
                data={hsndata}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                //  <Input
                //   value={rowData.priceFromeVendor}
                //   onChange={(value) => handleChange(rowIndex, 'priceFromeVendor', value)}
                // />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {sellingpriceC && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Selling Price Currency</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='SellingPriceCurrency' name="SellingPriceCurrency" 
                value={rowData && rowData.SellingPriceCurrency ? rowData.SellingPriceCurrency : ''}
                 onChange={value => handleChange(rowIndex,'SellingPriceCurrency', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {sellingpriceU && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Selling Price Unit</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='SellingPriceUnit' name="SellingPriceUnit" 
                value={rowData && rowData.SellingPriceUnit ? rowData.SellingPriceUnit : ''}
                 onChange={value => handleChange(rowIndex,'SellingPriceUnit', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {sellingPrice && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Selling Price</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='SellingPrice' name="SellingPrice" 
                 value={rowData && rowData.SellingPrice ? rowData.SellingPrice : ''}
                  onChange={value => handleChange(rowIndex,'SellingPrice', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {productCost && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Product Cost</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='ProductCost' name="ProductCost" 
                 value={rowData && rowData.ProductCost ? rowData.ProductCost : ''}
                  onChange={value => handleChange(rowIndex,'ProductCost', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {searchKeyword && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Search Keyword</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='SearchKeyword' name="SearchKeyword" 
                value={rowData && rowData.SearchKeyword ? rowData.SearchKeyword : ''}
                 onChange={value => handleChange(rowIndex,'SearchKeyword', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {moq && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>MOQ</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='MOQ' name="MOQ" 
                value={rowData && rowData.MOQ ? rowData.MOQ : ''}
                 onChange={value => handleChange(rowIndex,'MOQ', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {productDesigner && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Product Designer</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                 <Input id='ProductDesigner' name="ProductDesigner" 
                 value={rowData && rowData.ProductDesigner ? rowData.ProductDesigner : ''}
                  onChange={value => handleChange(rowIndex,'ProductDesigner', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          
          {madeby && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Made by</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='MadeBy' name="MadeBy" 
                value={rowData && rowData.MadeBy ? rowData.MadeBy : ''}
                 onChange={value => handleChange(rowIndex,'MadeBy', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {buyername && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Buyer name</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <Input id='BuyerName' name="BuyerName" 
                value={rowData && rowData.BuyerName ? rowData.BuyerName : ''}
                 onChange={value => handleChange(rowIndex,'BuyerName', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {buyersku && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Buyer SKU</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) =>
                 <Input id='BuyerSku' name="BuyerSku" 
                 value={rowData && rowData.BuyerSku ? rowData.BuyerSku : ''}
                  onChange={value => handleChange(rowIndex,'BuyerSku', value)} />
                }
              </Table.Cell>
            </Table.Column>
          )}
          {material && (
            <Table.Column width={150} >
              <Table.HeaderCell><b>Material</b></Table.HeaderCell>
              <Table.Cell>
                {(rowData, rowIndex) => 
                <SelectPicker
                // id="HSNCode"
                // name="HSNCode"
                // value={rowData && rowData.HSNCode ? rowData.HSNCode : ''}
                // onChange={value => handleChange(rowIndex,'HSNCode', value)}
                data={materialdata}
                placeholder="Select"
                labelKey="label"
                valueKey="value"
                block
              />
                }
              </Table.Cell>
            </Table.Column>
          )}   
          <Table.Column width={100} fixed="right">
            <Table.HeaderCell><b>Action</b></Table.HeaderCell>
            <Table.Cell>
              {(rowIndex) => (
                <IconButton icon={<TrashIcon />} active appearance="default"
                  onClick={() => handleRemoveRow(rowIndex)}
                  disabled={rows.length === 1} />
              )}
            </Table.Cell>
          </Table.Column>
        </Table>
        <Stack>
          <Button appearance="primary" color='cyan' onClick={handleAddRow}>
            Add Product
          </Button>
        </Stack>

        {/* Customize modal start */}
        <Modal size={size1} backdrop='static' open={open} onClose={handleClose}>
          <Modal.Header>
            <Modal.Title><b>Confirm the Attributes</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={category} onChange={handlecategoryCheckbox}>
                  Category
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={Productype} onChange={handlesubCategoryCheckbox}>
                  Product Type
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingPrice} onChange={handlesellingPriceCheckbox}>
                  Selling Price
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={moq} onChange={handlemoqCheckbox}>
                  MOQ
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={description} onChange={handledescriptionCheckbox}>
                  Description
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={searchKeyword} onChange={handlesearchKeywordCheckbox}>
                  Search Keyword
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productCost} onChange={handleproductCostCheckbox}>
                  Product Cost
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={material} onChange={handlematerialCheckbox}>
                  Material
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={color} onChange={handlecolorCheckbox}>
                  Color
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={size} onChange={handlesizeCheckbox}>
                  Size Unit
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={length} onChange={handlelenghtCheckbox}>
                Length
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={width} onChange={handlewidthCheckbox}>
                Width
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={height} onChange={handleheightCheckbox}>
                Height
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={cbm} onChange={handlecbmCheckbox}>
                 CBM
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productID} onChange={handlenameCheckbox}>
                Product ID
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productname} onChange={handleproductionTimeCheckbox}>
                Product Name
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={finish} onChange={handleremarksCheckbox}>
                Finish
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={netWeight} onChange={handlesamplingTimeCheckbox}>
                Net Wt.
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={grossweight} onChange={handleproductionTechCheckbox}>
                 Gross Wt.
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={collection} onChange={handlemodularSizeCheckbox}>
                Collection
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={hsn} onChange={handlepriceFromeVendorCheckbox}>
                  HSN
                </Checkbox>
              </FlexboxGrid.Item>
              
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingpriceU} onChange={handledispatchDataCheckbox}>
                Selling Price Unit
                </Checkbox>
              </FlexboxGrid.Item>
              
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={sellingpriceC} onChange={handleseasonCheckbox}>
                Selling Price Currency
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={productDesigner} onChange={handleexclusiveForCheckbox}>
                Product Designer
                </Checkbox>
              </FlexboxGrid.Item>
              
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={madeby} onChange={handleshapeCheckbox}>
                Made by
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyername} onChange={handlevendornameCheckbox}>
                Buyer Name
                </Checkbox>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={buyersku} onChange={handlethemeCheckbox}>
                Buyer SKU
                </Checkbox>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Checkbox checked={image} onChange={handleimageCheckbox}>
                  <b> Include Product Image</b>
                </Checkbox>
              </FlexboxGrid.Item>
            </FlexboxGrid>

          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='space-between'>
              <Button onClick={handleClose} appearance="ghost" color='cyan'>
                Cancel
              </Button>
              <Button onClick={handleClose} appearance="primary" color='cyan'>
                Done
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>
        {/* Customize modal End */}
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>
    </>

  );
};

export default BulkProduct;